import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import AboutUsSection from '../components/HomeDemoTwo/AboutUsSection';
import Partner from '../components/Common/Partner';
import TestimonialStyleTwo from '../components/Common/TestimonialStyleTwo';
import Footer from '../components/App/Footer';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';

const AboutUs = () => {
    return (
        <Layout>
            <SEO title="About Us" />

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="About Us" 
            />  
            
            <AboutUsSection />
            <StartProjectWithUs />
            

            {/* <Partner />

            <TestimonialStyleTwo /> */}
		  
			<Footer />
		</Layout>
    )
}

export default AboutUs;